<template>
<v-combobox
  v-model="selectedValue"
  :items="items"
  :label="label"
  :item-text="itemText"
  :item-value="itemValue"
  clearable
  hide-details
  outlined
  dense
  append-icon="mdi-magnify"
  :value-comparator="(a, b) => a.id === b.id"
  @update:model-value="handleModelUpdate"
  @update:search-input="handleSearchInput"
  @click:clear="clearInput"
>
  <template v-slot:item="{ item }">
    <div @click="handleItemClick(item)">{{ itemText(item) }}</div>
  </template>
  <template v-slot:selection="{ item }">
    {{ itemText(item) }}
  </template>
</v-combobox>
</template>

<script>
export default {
  name: 'ComboBox',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '100%'
    },
    outline: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    offsetY: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    fieldsForSearch: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: () => {},
    }
  },
  emits: ['update:modelValue', 'search'],
  data() {
    return {
      localSearch: '',
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (value) {
          this.handleModelUpdate(value);
        }
      }
    },
    itemText() {
      return (item) => {
        if (!item) return '';
        if (typeof item === 'object') {
          return `${item.id} - ${item.last_name || ''} ${item.first_name || ''}`.trim();
        }
        return String(item);
      };
    },
    itemValue() {
      return (item) => {
        if (typeof item === 'object' && item.id) {
          return `${item.id} - ${item.last_name || ''} ${item.first_name || ''}`.trim();
        }
        return item;
      };
    }
  },
  methods: {
    handleItemClick(item) {
      this.selectedValue = item;
      this.$emit('update:modelValue', item);
    },

    handleModelUpdate(value) {
      this.$emit('update:modelValue', value);
    },

    handleSearchInput(search) {
      if (search !== null && search !== undefined) {
        this.localSearch = search;
        this.$emit('search', search);
      }
    },

    clearInput() {
      this.$emit('update:modelValue', null);
    }

  }
};
</script>
